query Brand(
    $id: ID!
) {
    brand(id: $id) {
        id

        name

        legacyAlias
        legacyID
    }
}
